import {dedupingMixin} from "@polymer/polymer/lib/utils/mixin";

/**
 * @polymer
 * @mixinFunction
 **/
export const InputNumberSwapBehavior = dedupingMixin((superClass) => class extends superClass {
  static get properties() {
    return {
      _originalFormattedValue: {type: String}
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this._boundhandleWheel = this.handleWheel.bind(this);
    this.$.input.addEventListener('wheel', this._boundhandleWheel);

    if (!this.$.input.hasAttribute('step')) {
      this.$.input.setAttribute('step', 'any');
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.$.input.removeEventListener('wheel', this._boundhandleWheel);
  }

  displayValueChanged(newValue) {
    if (this.$.input.getAttribute('type') === 'number') {
      this.originalFormattedValue = newValue;
      return this.formatAsNumber(newValue);
    }
  }

  maxLengthChanged(newValue) {
    if (!newValue) {
      return;
    }
    const [precision, scale] = newValue.toString().split('.');
    if (precision) {
      const scaleLength = (scale ? parseInt(scale, 10) : 0);
      let maxValue = '9'.repeat(parseInt(precision, 10) - scaleLength);
      if (scaleLength) {
        maxValue += `.${'9'.repeat(scaleLength)}`;
      }
      this.$.input.setAttribute('max', maxValue);
    }
    return false;
  }

  handleWheel(event) {
    if (this.focused) {
      event.preventDefault();
    }
  }

  focusInput() {
    if (this.focused || this.disabled) {
      return;
    }
    if (this.$.input.value) {
      this.originalFormattedValue = this.$.input.value;
      this.$.input.value = this.formatAsNumber(this.originalFormattedValue);
    }
    this.$.input.setAttribute('type', 'number');
  }

  handleBlur() {
    this.$.input.setAttribute('type', 'text');
    if (this.originalFormattedValue && this.formatAsNumber(this.originalFormattedValue) === this.formatAsNumber(this.$.input.value)) {
      this.$.input.value = this.originalFormattedValue;
    }
  }

  formatAsNumber(value) {
    if (typeof value === 'string' && /[^\d.+\-]/.test(value)) {
      value = value.replace(/[^\d.+\-]/g, '');
    }
    return value;
  }
});